import styled from "styled-components";

interface BoxButtonsProps {
  displayed?: boolean
}

interface BtnProps {
  isSelected?: boolean
}

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;
  padding: 0 5px;

  h3 {
    width: 350px;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 16px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    strong {
      color: ${props => props.theme.colors.mainColor};
    }
  }

  small {
    width: 350px;
    margin-bottom: 20px;
    text-align: center;

    font-size: 14px;
    line-height: 16px;
    color: ${props => props.theme.colors.grey04};
  }
`

export const Cards = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 0 20px;

  > h3 {
    margin-bottom: 0;

    &:nth-child(2) {
      margin: 10px;
    }
  }

  small#value {
    margin: 12px 0 8px;
    font-size: 16px;
    color: ${props => props.theme.colors.grey03};

    display: flex;
    align-items: center;
    justify-content: center;

    > span {
      font-weight: 600;
      color: ${props => props.theme.colors.mainColor};
    }

    > svg {
      margin-left: 8px;
      cursor: pointer;
      color: ${props => props.theme.colors.warning};
    }
  }
`

export const BoxButtons = styled.div<BoxButtonsProps>`
  display: flex;
  align-items: center;
  justify-content: space-around;

  margin-top: 15px;
  width: 200px;

  span {
    font-size: 24px;
    margin: 4px;
    font-weight: 600;
    color: ${props => props.theme.colors.greyDarker}
  }
`

export const ButtonSimulationCalc = styled.button<BtnProps>`
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${props => props.theme.colors.whiteDarker};
  border: none;
  border-radius: 4px;
  transition: all .2s ease;

  svg {
    width: 16px;
    height: 16px;
    color: ${props => props.theme.colors.grey03};
    transition: all .2s ease;
  }

  &:hover {
    background-color: ${props => props.theme.colors.mainColor};
    transition: all .2s ease;

    svg {
      transition: all .2s ease;
      color: ${props => props.theme.colors.whiteDarker};
    }
  }
`
